import React, { useEffect, useState } from "react";
import axios from "axios";
import { SidebarMain } from "../ui/sidebar-main";
import { MultiStepLoader } from "../ui/loader";
import Chat from "./chat";
import Personas from "./personas";
import Competitors from "./comp";
import SocialMedia from "./social-media";
// import { FaRegEdit } from "react-icons/fa";
// import { GoPlusCircle } from "react-icons/go";
import Cookies from "js-cookie";

const Overview = () => {
  const [data, setData] = useState(null);
  const wId = Cookies.get("workspaceId");
  const base_url = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (wId) {
      Cookies.set("workspaceId", wId, { expires: 7 });
    }
  }, [wId]);

  const MAX_RETRIES = 5;

  const fetchDataWithRetry = async (setData, base_url, wId) => {
    let attempts = 0;
  
    while (attempts < MAX_RETRIES) {
      try {
        const response = await axios.get(`${base_url}/get-dashboard`, {
          headers: { workspaceId: wId },
        });
        console.log(response.data);
        setData(response.data);
        return; // Exit function on success
      } catch (error) {
        attempts++;
        console.error(`Attempt ${attempts} failed:`, error);
        if (attempts === MAX_RETRIES) {
          console.error("Max retries reached. Failed to fetch data.");
        } else {
          console.log("Tried again");
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      }
    }
  };
  
  useEffect(() => {
    fetchDataWithRetry(setData, base_url, wId);
  }, []);

  if (!data) {
    return (
      <div>
        <MultiStepLoader
          loadingStates={[
            { text: "Fetching Data" },
            { text: "Loading Dashboard" },
          ]}
          loading={true}
          duration={1000}
          loop={false}
        />
      </div>
    );
  }

  const { cards, oneLiner, description } = data;

  const customerSegmentation = cards.find(
    (card) => card.card_type === "CustomerSegmentation"
  )?.card_json;

  const competitorAnalysis = cards.find(
    (card) => card.card_type === "CompetitorAnalysis"
  )?.card_json;

  const socialMediaPosts = cards.find(
    (card) => card.card_type === "SocialMediaPosts"
  )?.card_json;

  return (
    // <div className="flex min-h-screen bg-dot-slate-300">
  <div className="flex min-h-screen">
      <SidebarMain />
      <div className="flex flex-col gap-4 py-4 px-6">
        <div className="flex flex-row">
          <div className="w-4/5 flex flex-col gap-2">
            <h1 className="text-3xl text-left capitalize font-semibold">
              {oneLiner}
            </h1>
            <p className="text-gray-500 w-5/6 text-left">{description}</p>
          </div>
          {/* <div className="flex flex-col gap-2 pl-10">
            <button className="px-4 py-3 rounded-md border border-black bg-white text-black font-bold tracking-wide hover:shadow-[4px_4px_0px_0px_rgba(0,0,0)] transition duration-200 uppercase text-sm flex flex-row gap-2 justify-center">
              <FaRegEdit size={20} />
              edit your base idea
            </button>
            <button className="px-4 py-3 rounded-md border border-black bg-white text-black font-bold tracking-wide hover:shadow-[4px_4px_0px_0px_rgba(0,0,0)] transition duration-200 uppercase text-sm flex flex-row gap-2 justify-center">
              <GoPlusCircle size={20} />
              add new feature
            </button>
          </div> */}
        </div>
        <div className="">
          {competitorAnalysis && <Competitors data={competitorAnalysis} />}
        </div>
        <div className="flex flex-row items-stretch gap-6">
          <div className="flex-1">
            {customerSegmentation && <Personas data={customerSegmentation} />}
          </div>

          <div className="flex-1 h-[28.5rem]">
            {socialMediaPosts && <SocialMedia posts={socialMediaPosts} />}
          </div>
        </div>
      </div>
      {/* <Chat /> */}
    </div>
  );
};

export default Overview;
